/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import { GridRowId } from "@mui/x-data-grid-pro";
import React from "react";
import { useStoreDispatch } from "../../../../store/hooks";
import { useSelector } from "react-redux";
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import { setScheduledTask } from "../../../../store/api/tasks/reducer";
import { setDebugArrayToSting } from "../../helpers";
import { iconButtonSxProps } from "../../../helpers";
import { IconButton } from "@mui/material";
import { tasksSelector } from "../../../../store/api/tasks/selector";



interface IDeleteRowFromSetDebugProps {
    id: GridRowId
}
const DeleteRowFromSetDebug: React.FC<IDeleteRowFromSetDebugProps> = ({ id }) => {
    const dispatch = useStoreDispatch();
    const { setDebugRows } = useSelector(tasksSelector);
    const handleDeleteClick = (id: GridRowId) => () => {
        const newdata = setDebugRows.length > 0 ? setDebugRows.filter((row: any) => row.id !== id) : [];
        dispatch(setScheduledTask({ setDebug: setDebugArrayToSting(newdata), setDebugRows: newdata }));
    };
    return (
        <>
            <IconButton
                aria-label="delete"
                onClick={handleDeleteClick(id)}
                sx={iconButtonSxProps} >
                <DeleteIcon color="error" fontSize="small" />
            </IconButton>
        </>

    )
}

export default DeleteRowFromSetDebug;